// extracted by css-extract-rspack-plugin
export default {"wrapper":"AgentTypeTrailingVisual-module__wrapper__TXEtD","connectedDot":"AgentTypeTrailingVisual-module__connectedDot__eJh84"};